<template>
  <div class="max-w-sm w-1/2 lg:max-w-full lg:flex shadow-lg">
    <div
      v-if="imageSrc"
      class="h-48 lg:h-auto lg:w-48 flex-none bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden"
      :style="{ backgroundImage: `url('${imageSrc}')` }"
      :title="imageAlt"
    ></div>
    <div class="bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
      <slot>
        <div v-if="slides.length === 0">
          <div class="mb-8">
            <div class="text-gray-900 font-site font-bold text-2xl mb-2 text-wine">{{ title }}</div>
            <p class="text-gray-700 text-base">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptatibus quia, nulla! Maiores et perferendis
              eaque, exercitationem praesentium nihil.
            </p>
          </div>
          <button class="inline-block bg-gray-200 rounded px-8 py-6 mt-4 text-sm font-semibold text-gray-700">
            {{ callToAction }}
          </button>
        </div>
        <carousel v-else :slides="slides" :autoplay="autoplay" />
      </slot>
    </div>
  </div>
</template>

<script>
import cardMixin from '@/components/card/card.mixin'
import Carousel from '@/components/layout/Carousel'

export default {
  components: { Carousel },
  mixins: [cardMixin],
}
</script>
